import Vue from 'vue';
import router from './router/index'
import 'normalize.css/normalize.css'
import ElementUI from 'element-ui';
import './style/element-variables.scss'
import './style/index.scss' // global css
// import './style/element-variables.scss'
import "@/style/font/font.scss";
import './plugins/index'; // 引入挂载的vue实例方法文件
import { createPinia, PiniaVuePlugin } from 'pinia';
import './router/routerConfig'; // 引入路由守卫
import App from './App.vue';
import * as echarts from 'echarts';
import 'video.js/dist/video-js.css'


Vue.use(PiniaVuePlugin);
const pinia = createPinia();

Vue.prototype.$echarts = echarts;
Vue.use(ElementUI, {size: 'small'});
Vue.config.productionTip = false;

new Vue({
  pinia,
  router,
  render: h => h(App),
}).$mount('#app')
